// Tiny event bridge for the v3 Consultation layout's "→ Move these to the
// prescription" hand-off (docs/design/consultation/Conversation.dc.html
// marker 4): the note canvas (inside ConsultationChat.tsx) hands the Plan
// section's raw text to PrescriptionBuilder.tsx, which is already mounted
// beside it (forceMount, see ConsultStage.tsx) so a plain CustomEvent
// reaches it without threading a new prop through ConsultStage just to
// carry this one payload — the same "read once, no persistence" shape as
// VoiceIntake.tsx's window globals (see CLAUDE.md), a DOM event rather than
// a window property since there's nothing here that needs to survive past
// the moment it's dispatched.
export const PLAN_HANDOFF_EVENT = 'hms:consultation-plan-handoff';

export interface PlanHandoffDetail {
  /** The Plan section's own markdown lines (heading included), passed
   * straight to PrescriptionBuilder.tsx's existing parseAiPrescriptionTable(). */
  text: string;
}

export function dispatchPlanHandoff(text: string): void {
  window.dispatchEvent(new CustomEvent<PlanHandoffDetail>(PLAN_HANDOFF_EVENT, { detail: { text } }));
}
